import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { UrlParser } from "@/features/ui/helpers/url-parser";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import useFetcher from "@/utils/use-fetcher";

export interface ImageCheckLineSheetSetRequest {}
export interface ImageCheckLineSheetSetResponse {}
export interface ImageCheckLineSheetSetParameter {
  agencyId: number;
  lineSheetSetId: number;
}

export const imageCheckLineSheetSetTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/ai_image_check";

export const imageCheckLineSheetSetKey: YWRKey<ImageCheckLineSheetSetParameter> = {
  url: (parameter) => {
    return calcUrl(imageCheckLineSheetSetTemplateUrl, parameter);
  },
  method: "post",
};

export function parseImageCheckLineSheetSetKey(url: string) {
  const urlParser = new UrlParser<ImageCheckLineSheetSetParameter>(
    imageCheckLineSheetSetTemplateUrl,
    {
      agencyId: StringTransformer.parseId,
      lineSheetSetId: StringTransformer.parseId,
    }
  );
  return {
    parameter: urlParser.parse(url),
    method: "post",
  };
}

export default function useImageCheckLineSheetSet() {
  const fetcher = useFetcher<
    ImageCheckLineSheetSetRequest,
    ImageCheckLineSheetSetResponse
  >();
  return useYWR(imageCheckLineSheetSetKey, fetcher);
}
